<template>
  <div class="row justify-content-center py-xl-5 mt-6 mt-xl-8 mt-lg-8 mt-md-9 h-100">
    <div class="col-md-8 col-xl-7">
        <div class="px-lg-4">
          <form role="form" @submit="validateForm">
            <base-input class="input-group-alternative mb-3"
                        :placeholder="[[variables.get('email')]]"
                        addon-left-icon="ni ni-email-83"
                        v-model="model.email">
            </base-input>
            <div class="alert alert-danger" v-for="(error , index) in validationErrors.email" :key="index">
              * {{ error }}
            </div>
            <div class="alert alert-danger" v-if="result !== null">
              * {{ result }}
            </div>
            <div class="text-right">
              <base-button type="button" native-type="submit" 
              class="btn bg-vg-green text-white w-100"
              v-loading="loading"
              :disabled="loading">
                {{ variables.get('reset-password') }}
              </base-button>
            <p class="text-center mb-0 mt-2">
              <small class="text-grey font-montserrat"
                >Kayıtlı Değil Misiniz?</small
              >
              <router-link to="/register">
                <small class="text-vg-blue font-montserrat font-weight-bold">
                  {{ variables.get("register") }}
                </small>
              </router-link>
            </p>
            <p class="text-center">
              <small class="text-grey font-montserrat"
                >Kayıtlı mısınız?</small
              >
              <router-link to="/login">
                <small
                  class="pl-1 text-vg-blue font-montserrat font-weight-bold"
                  >{{ variables.get("login") }}</small
                >
              </router-link>
            </p>
            </div>
          </form>
        </div>
    </div>
  </div>
</template>
<script>
import {variables} from '../langs/tr'
import * as axios from "axios";

export default {
  name: 'reset-password',
  data() {
    return {
      loading: false,
      variables,
      validationErrors: {
        email: []
      },
      model: {
        email: ''
      },
      result: null
    }
  },
  methods: {
    validateForm: function (e) {
      this.validationErrors = {
        email: []
      };
      this.result = null;
      if (!this.model.email) {
        this.validationErrors.email.push('E-posta adresi gereklidir');
      }
      if (this.model.email && !this.validEmail(this.model.email)) {
        this.validationErrors.email.push('Hatalı e-posta adresi');
      }
      if (this.validationErrors.email.length === 0) {
        this.reset();
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    reset() {
      this.loading = true;
      axios
          .post('reset-password', {email: this.model.email})
          .then(response => {
            if (response.status === 200) {
              this.result = 'Şifreniz e-posta adresinize gönderilmiştir.'
            }
            this.loading = false;
          })
          .catch(error => {
            this.result = error.response.data.messages[0];
            this.loading = false;
          });
    }
  }
}
</script>
<style>
@import "../assets/css/custom.css";
.alert {
  padding: .5rem 1rem;
}
</style>

